import config from "../config/config.js";
import ResourceHelper from "@common/globalization/ResourceHelper";

//Check the user authentication to access the modules
export const checkAuth = (cookieName, moudleName, displayMessage = true) => {
    if (config.EnableModuleRestriction) {
        let cookieData = getCookie(cookieName);
        let arrayOfCookieData = cookieData.replace('[', '').replace(']', '').replaceAll('"', '').split(',');
        if (cookieData && cookieData.length > 0) {
            const authorized = arrayOfCookieData.includes(moudleName)
            if (authorized) {
                return true;
            } else {
                if (displayMessage) {
                    let message = `<div class="not-authorized-message">
                                <h4">${ResourceHelper.getString('NotAuthMessage')}</h4>
                           </div>`;
                    let panel = document.querySelector('.ContentPane');

                    panel.insertAdjacentHTML('afterbegin', message);
                }
                return false;
            }

        } else {
            return false;
        }
    } else {
        return true;
    }
}

//Generate url
export const generateLink = (filterValue, type, displayName) => {
    let querySearch = {
        "query": "",
        "page": 1,
        "size": 10,
        "sortFilter": [],
        "afterSearchParameters": [
            {
                "FieldName": type,
                "FieldValue": filterValue,
                "displayName": displayName ? displayName : filterValue,
                "countValue": ""
            }
        ]
    }
    let searchUrl = getCookie("searchUrl");
    let url = `${searchUrl}?SearchQuery=${JSON.stringify(querySearch)}`;
    console.log(url);
    return encodeURI(url);
}